export const links = {
    brukerprofil: 'https://tjenester.nav.no/brukerprofil/',
    brukerstøtte:
        'https://www.nav.no/no/NAV+og+samfunn/Kontakt+NAV/Teknisk+brukerstotte/hjelp-til-personbruker?kap=398749',
    kontaktOss: 'https://www.nav.no/person/kontakt-oss/nb/tilbakemeldinger/feil-og-mangler',
    dittNav: 'https://tjenester.nav.no/dittnav/oversikt',
    foreldrepenger: 'https://foreldrepenger.nav.no',
    foreldrepengesoknad: 'https://nav.no/foreldrepenger/soknad',
    foreldrepengerFarOgFar: 'https://www.nav.no/foreldrepenger#far-far',
    foreldrepengerOpptjening: 'https://www.nav.no/foreldrepenger#opptjening',
    nav: 'https://www.nav.no',
    papirsøknad: 'https://www.nav.no/soknader/nb/person/familie/foreldrepenger-og-engangsstonad',
    papirsøknadSvp: 'https://www.nav.no/start/soknad-svangerskapspenger?stegvalg=1',
    personvernerklæring:
        'https://www.nav.no/no/NAV+og+samfunn/Om+NAV/personvern-i-arbeids-og-velferdsetaten/personvernerkl%C3%A6ring-for-arbeids-og-velferdsetaten',
    arbeidsforholdMineSider: 'https://www.nav.no/person/personopplysninger/nb/#arbeidsforhold',
    personvernerklæringOm: 'https://www.nav.no/personvernerklaering#om',
    forelderpengerHvorLenge: 'https://www.nav.no/foreldrepenger#hvor-lenge',
    plikter: 'https://www.nav.no/endringer',
    søknadsveileder: 'https://www.nav.no/soknader/nb/person/familie/foreldrepenger-og-engangsstonad',
    veiviser: 'https://www.nav.no/foreldrepenger/foreldrepenger-eller-engangsstonad',
    innsyn: 'https://foreldrepenger.nav.no',
    engangsstonad: 'https://www.nav.no/engangsstonad',
    farMedmor: 'https://www.nav.no/engangsstonad#far_medmor',
    barn: 'https://www.nav.no/barn',
    foreldrepengerUtland: 'https://www.nav.no/foreldrepenger#utland',
    engangsstonadHvem: 'https://www.nav.no/engangsstonad#hvem',
    scanneDokument: 'https://www.nav.no/brukerstotte#bilde-vedlegg',
    svangerskapspengerUtland: 'https://www.nav.no/no/person/familie/relatert-informasjon/svangerskapspenger-og-utland',
    søknadsfrister: 'https://www.nav.no/foreldrepenger#for-soknad',
    opphold: 'https://www.nav.no/foreldrepenger#opphold',
    hvorLenge: 'https://www.nav.no/foreldrepenger#hvor-lenge',
    hvorMye: 'https://www.nav.no/foreldrepenger/hvor-mye',
    svangerskapspenger: 'https://familie.nav.no/om-svangerskapspenger',
    tilretteleggingsskjema:
        'https://www.arbeidstilsynet.no/tema/graviditet-og-arbeidsmiljo/skjema-for-tilrettelegging-for-gravide/',
    rettOgPlikt: 'https://www.nav.no/endringer',
    slikSøkerDuSvp: 'https://familie.nav.no/om-svangerskapspenger#slik-soker-du',
    arbeidstilsynetSkjema:
        'https://www.arbeidstilsynet.no/tema/graviditet-og-arbeidsmiljo/skjema-for-tilrettelegging-for-gravide/',
    frilanserInfoBoks:
        'https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/a-meldingen/veiledning/arbeidsforholdet/' +
        'type-arbeidsforhold/frilanser-oppdragstaker-og-personer-som-mottar-honorarer/',
    næringsdrivendeInfoBoks:
        'https://www.skatteetaten.no/bedrift-og-organisasjon/starte-og-drive/er-jeg-naringsdrivende/',
    selvstendigNæringsdrivendeHvorMye: 'https://www.nav.no/foreldrepenger#hvor-mye',
    hvordanSendeInntektsmelding:
        'https://www.nav.no/no/bedrift/tjenester-og-skjemaer/nav-og-altinn-tjenester/foreldrepenger-og-svangerskapspenger2',
    omLottOgHyre: 'https://www.skatteetaten.no/en/rettskilder/type/handboker/skatte-abc/2021/fiske/F-13.014/F-13.048/',
    adoptere: 'https://www.nav.no/no/person/familie/foreldrepenger/foreldrepenger#adoptere',
    fleksibeltuttak: 'https://www.nav.no/no/person/familie/foreldrepenger/foreldrepenger#samtidig',
    viktigeFrister: 'https://www.nav.no/no/person/familie/foreldrepenger/foreldrepenger#for-soknad',
    nav_aktivitetskrav: 'https://www.nav.no/no/person/familie/foreldrepenger/foreldrepenger#hvor-lenge',
    morsAktivitetskrav: 'https://www.nav.no/no/person/familie/foreldrepenger/foreldrepenger#hvor-lenge',
    familie: 'https://familie.nav.no/',
    graderingInfo: 'https://www.nav.no/no/person/familie/foreldrepenger/foreldrepenger#arbeid',
    aktivitetsfriUttakInfo: 'https://www.nav.no/foreldrepenger#hvor-lenge',
    farskapsportal: 'https://farskapsportal.nav.no/',
    barnehageloven: 'https://lovdata.no/nav/lov/2005-06-17-64/kapIV/%C2%A716',
    godkjentAktivitet: 'https://www.nav.no/foreldrepenger#hvor-lenge',
    søknadForeldrepenger: 'https://www.nav.no/start/soknad-foreldrepenger',
    søknadEngangsstønad: 'https://www.nav.no/start/soknad-engangsstonad',
    grunnbeløpet: 'https://www.nav.no/grunnbelopet',
    folketrygden:
        'https://www.nav.no/no/person/flere-tema/arbeid-og-opphold-i-norge/relatert-informasjon/medlemskap-i-folketrygden',
    omForeldrepenger: 'https://www.nav.no/foreldrepenger',
    utbetalingsoversikt: 'https://www.nav.no/utbetalingsoversikt/',
    foreldrepengerPlanlegger: 'https://www.nav.no/foreldrepenger/planlegger/',
};
